window.image_path = (name) => {
  return `/backbone/assets/images/${name}`
}

window.icon_for = (subtype) => {
  return {
    'apple_app_store' : 'apple_app_store',
    'apple_app_store_review_comment' : 'app-store-public',
    'DirecTvFormTest': 'directv-mini',
    'DirecTvFormCH': 'directv-mini',
    'DirecTvFormCO': 'directv-mini',
    'DirecTvFormEC': 'directv-mini',
    'DirecTvFormPE': 'directv-mini',
    'DirecTvFormUY': 'directv-mini',
    'facebook': 'facebook-public',
    'fb-post': 'facebook-public',
    'fb-comment': 'facebook-public',
    'fb-user': 'facebook-public',
    'fb-message': 'facebook-private',
    'twitter': 'twitter-public',
    'tweet': 'twitter-public',
    'tw-user': 'twitter-public',
    'retweet': 'twitter-public',
    'quote': 'twitter-public',
    'direct-message': 'twitter-private',
    'instagram': 'instagram',
    'ig-comment': 'instagram',
    'ig-comment-live': 'instagram',
    'instagramComment': 'instagram',
    'ig-video': 'instagram',
    'ig-image': 'instagram',
    'ig-live': 'instagram',
    'ig-message': 'instagram',
    'instagram_listening_media': 'instagram',
    'instagram_business_discovery_listening_media': 'instagram',
    'ig-story': 'instagram',
    'ig-user': 'instagram',
    'email': 'mail',
    'email-user': 'mail',
    'youtube': 'youtube',
    'yt-comment': 'youtube',
    'yt-video': 'youtube',
    'gp_review_comment': 'google-play-public',
    'google_play': 'google_play',
    'yt-user': 'youtube',
    'webchat': 'chat',
    'webchat-message': 'chat',
    'webchat-start': 'chat',
    'claim-message': 'ra-icon-1-x',
    'whatsapp': 'wa-logo',
    'whatsapp_message': 'wa-logo',
    'whatsapp_message-user': 'wa-logo',
    'li-post': 'li-icon',
    'li-comment': 'li-icon',
    'li-user': 'li-icon',
    'linkedin': 'li-icon',
    'google-my-business-review': 'google-my-business',
    'google-my-business-reply': 'google-my-business',
    'google-my-business': 'google-my-business',
    'tiktok-ad': 'tiktok',
    'tiktok-comment': 'tiktok',
    'tiktok-dm': 'tiktok',
    'tiktok-post': 'tiktok',
    'tiktok-user': 'tiktok',
    'tiktok': 'tiktok'
  }[subtype] || 'chat'
}

window.id_icon_for = (subtype) => {
  return {
    'apple_app_store_review_comment' : 'id-app-store',
    'facebook': 'id-facebook',
    'fb-post': 'id-facebook',
    'fb-comment': 'id-facebook',
    'fb-user': 'id-facebook',
    'fb-message': 'id-facebook',
    'twitter': 'id-twitter',
    'tweet': 'id-twitter',
    'tw-user': 'id-twitter',
    'retweet': 'id-twitter',
    'quote': 'id-twitter',
    'direct-message': 'id-twitter',
    'instagram': 'id-instagram',
    'ig-comment': 'id-instagram',
    'ig-comment-live': 'id-instagram',
    'ig-video': 'id-instagram',
    'ig-image': 'id-instagram',
    'ig-live': 'id-instagram',
    'ig-message': 'id-instagram',
    'ig-story': 'id-instagram',
    'ig-user': 'id-instagram',
    'email': 'id-mail',
    'email-user': 'id-mail',
    'youtube': 'id-youtube',
    'yt-comment': 'id-youtube',
    'yt-video': 'id-youtube',
    'gp_review_comment': 'id-google-play',
    'yt-user': 'id-youtube',
    'webchat': 'id-webchat',
    'webchat-message': 'id-webchat',
    'webchat-start': 'id-webchat',
    'whatsapp_message': 'id-whatsapp',
    'whatsapp_message-user': 'id-whatsapp',
    'li-comment': 'id-linkedin',
    'li-post': 'id-linkedin',
    'li-user': 'id-linkedin',
    'DirecTvFormTest': 'id-twitter',
    'DirecTvFormCH': 'id-twitter',
    'DirecTvFormCO': 'id-twitter',
    'DirecTvFormEC': 'id-twitter',
    'DirecTvFormPE': 'id-twitter',
    'DirecTvFormUY': 'id-twitter',
    'google-my-business-review': 'id-google-my-business',
    'google-my-business-reply': 'id-google-my-business',
    'tiktok-ad': 'id-tiktok',
    'tiktok-comment': 'id-tiktok',
    'tiktok-dm': 'id-tiktok',
    'tiktok-post': 'id-tiktok',
    'tiktok-user': 'id-tiktok',
    'tiktok': 'id-tiktok'
  }[subtype] || 'id-webchat'
}

window.color_for = (subtype) => {
  return {
    'apple_app_store' : '#006ab0',
    'apple_app_store_review_comment' : '#006ab0',
    'facebook': '#3b5998',
    'fb-post': '#3b5998',
    'fb-comment': '#3b5998',
    'fb-user': '#3b5998',
    'fb-message': '#3b5998',
    'twitter': '#55abde',
    'tweet': '#55abde',
    'retweet': '#55abde',
    'quote': '#1B5997',
    'direct-message': '#55abde',
    'tw-user' : '#55abde',
    'instagram': '#930093',
    'ig-comment': '#930093',
    'ig-comment-live': '#930093',
    'ig-video': '#930093',
    'ig-image': '#930093',
    'ig-live': '#930093',
    'ig-message': '#930093',
    'ig-story': '#930093',
    'ig-user': '#930093',
    'email': '#61a126',
    'email-user': '#61a126',
    'youtube': '#cb291e',
    'yt-comment': '#cb291e',
    'yt-video': '#cb291e',
    'yt-user': '#cb291e',
    'gp_review_comment': '#d1aa48',
    'google_play': '#d1aa48',
    'webchat': '#f9690e',
    'webchat-message': '#f9690e',
    'webchat-start': '#f9690e',
    'whatsapp': '#25d366',
    'whatsapp_message': '#25d366',
    'whatsapp_message-user': '#25d366',
    'li-comment': '#2176b8',
    'li-post': '#2176b8',
    'li-user': '#2176b8',
    'DirecTvFormTest': '#1B5997',
    'DirecTvFormCH': '#1B5997',
    'DirecTvFormCO': '#1B5997',
    'DirecTvFormEC': '#1B5997',
    'DirecTvFormPE': '#1B5997',
    'DirecTvFormUY': '#1B5997',
    'google-my-business-review': '#304696',
    'google-my-business-reply': '#304696',
    'tiktok-ad': '#000000',
    'tiktok-comment': '#000000',
    'tiktok-dm': '#000000',
    'tiktok-post': '#000000',
    'tiktok-user': '#000000',
    'tiktok': '#000000'
  }[subtype] || '#f9690e'
}

window.referrer_policy_for = (url) => {
  try {
    const host = new URL(url, window.location.href).hostname
    return /(^|\.)(twimg\.com|twitter\.com|x\.com)$/.test(host) ? 'no-referrer' : ''
  } catch (e) {
    return ''
  }
}

window.default_avatar_for = (subtype) => {
  return {
    'reclameaqui': window.image_path('default_avatars/reclameaqui/reclameaqui.png'),
    'apple_app_store': window.image_path('default_avatars/apple_app_store/apple_app_store.png'),
    'apple_app_store_review_comment': window.image_path('default_avatars/apple_app_store/apple_app_store.png'),
    'DivTvFormTest': window.image_path('default_avatars/directv-mini/directv-mini.png'),
    'DirecTvFormTest': window.image_path('default_avatars/directv-mini/directv-mini.png'),
    'DirecTvFormCH': window.image_path('default_avatars/directv-mini/directv-mini.png'),
    'DirecTvFormCO': window.image_path('default_avatars/directv-mini/directv-mini.png'),
    'DirecTvFormEC': window.image_path('default_avatars/directv-mini/directv-mini.png'),
    'DirecTvFormPE': window.image_path('default_avatars/directv-mini/directv-mini.png'),
    'DirecTvFormUY': window.image_path('default_avatars/directv-mini/directv-mini.png'),
    'facebook': window.image_path('default_avatars/facebook/facebook.png'),
    'fb-post': window.image_path('default_avatars/facebook/facebook.png'),
    'fb-comment': window.image_path('default_avatars/facebook/facebook.png'),
    'fb-user': window.image_path('default_avatars/facebook/facebook.png'),
    'fb-message': window.image_path('default_avatars/facebook/facebook.png'),
    'twitter': window.image_path('default_avatars/twitter/twitter.png'),
    'tweet': window.image_path('default_avatars/twitter/twitter.png'),
    'tw-user': window.image_path('default_avatars/twitter/twitter.png'),
    'retweet': window.image_path('default_avatars/twitter/twitter.png'),
    'quote': window.image_path('default_avatars/twitter/twitter.png'),
    'direct-message': window.image_path('default_avatars/twitter/twitter.png'),
    'instagram': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-comment': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-comment-live': window.image_path('default_avatars/instagram/instagram.png'),
    'instagramComment': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-video': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-image': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-live': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-message': window.image_path('default_avatars/instagram/instagram.png'),
    'instagram_listening_media': window.image_path('default_avatars/instagram/instagram.png'),
    'instagram_business_discovery_listening_media': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-story': window.image_path('default_avatars/instagram/instagram.png'),
    'ig-user': window.image_path('default_avatars/instagram/instagram.png'),
    'email': window.image_path('default_avatars/email/email.png'),
    'email-user': window.image_path('default_avatars/email/email.png'),
    'youtube': window.image_path('default_avatars/youtube/youtube.png'),
    'yt-comment': window.image_path('default_avatars/youtube/youtube.png'),
    'yt-video': window.image_path('default_avatars/youtube/youtube.png'),
    'yt-user': window.image_path('default_avatars/youtube/youtube.png'),
    'gp_review_comment': window.image_path('default_avatars/google_play/google_play.png'),
    'google_play': window.image_path('default_avatars/google_play/google_play.png'),
    'webchat': window.image_path('default_avatars/chat/chat.png'),
    'webchat-message': window.image_path('default_avatars/chat/chat.png'),
    'webchat-start': window.image_path('default_avatars/chat/chat.png'),
    'claim-message': window.image_path('default_avatars/ra-icon-1-x.png'),
    'whatsapp': window.image_path('default_avatars/whatsapp/whatsapp.png'),
    'whatsapp_message': window.image_path('default_avatars/whatsapp/whatsapp.png'),
    'whatsapp_message-user': window.image_path('default_avatars/whatsapp/whatsapp.png'),
    'li-post': window.image_path('default_avatars/linkedin/linkedin.png'),
    'li-comment': window.image_path('default_avatars/linkedin/linkedin.png'),
    'li-user': window.image_path('default_avatars/linkedin/linkedin.png'),
    'linkedin': window.image_path('default_avatars/linkedin/linkedin.png'),
    'google-my-business-review': window.image_path('default_avatars/google_my_business/google-my-business.png'),
    'google-my-business-reply': window.image_path('default_avatars/google_my_business/google-my-business.png'),
    'tiktok-ad': window.image_path('default_avatars/tiktok/tiktok_ad.png'),
    'tiktok-comment': window.image_path('default_avatars/tiktok/tiktok.png'),
    'tiktok-dm': window.image_path('default_avatars/tiktok/tiktok.png'),
    'tiktok-post': window.image_path('default_avatars/tiktok/tiktok.png'),
    'tiktok-user': window.image_path('default_avatars/tiktok/tiktok.png'),
    'tiktok': window.image_path('default_avatars/tiktok/tiktok.png')
  }[subtype]
}
